export default function VuexEventListenerPlugin(emitter) {
    return (store) => {
        emitter.on('planning-slots-changed', (eventValues) => {
            const mode = store.state.planning.mode;

            const taskIds = eventValues.taskIds;
            const personIds = eventValues.personIds;
            const teamIds = eventValues.teamIds;
            const equipmentIds = eventValues.equipmentIds;

            switch (mode) {
                case 'project':
                    store.dispatch('planning/requestItemSlots', { itemsIds: taskIds });
                    break;
                case 'person':
                    store.dispatch('planning/requestItemSlots', { itemsIds: personIds });
                    break;
                case 'equipment':
                    store.dispatch('planning/requestItemSlots', { itemsIds: equipmentIds });
                    break;
                case 'team':
                    store.dispatch('planning/requestItemSlots', { itemsIds: teamIds });
                    break;
                case 'capacityPerson':
                    store.dispatch('planning/requestItemCapacity', { itemsIds: personIds });
                    store.dispatch('planning/requestCompanyCapacity');
                    break;
            }
        });

        emitter.on('planning-absences-changed', (eventValues) => {
            const mode = store.state.planning.mode;

            switch (mode) {
                case 'project':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'person':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'team':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'capacityPerson':
                    store.dispatch('planning/requestItemCapacity', {
                        itemsIds: eventValues.itemIds,
                    });
                    store.dispatch('planning/requestCompanyCapacity');
                    break;
            }
        });
    };
}
